import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import hrTranslations from './locales/hr.json';
import ptTranslations from './locales/pt.json';

i18n
  .use(LanguageDetector) // Detects the user's language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enTranslations },
      pt: { translation: ptTranslations },
      hr: { translation: hrTranslations },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React handles escaping
  });

export default i18n;
